export default "__VITE_ASSET__bwD5lznR__"